<!-- CopyRight (C) 2017-2022 Alibaba Group Holding Limited. -->
<!-- Created by Tw93 on 16/10/28. -->
<!-- Updated by Tw93 on 17/01/06. -->

<template>
  <div>

    <v-radio-group v-model="radioModel" @change="wxcRadioItemCheckedNew">
      <template v-slot:label v-if="label">
        <div><span :style="radioLabelStyle" v-html="label"></span></div>
      </template>
      <div :style="radioItemStyle" v-for="(item,index) in updateList" :key="item.title+index">
        <v-radio :value="item.value">
          <template v-slot:label>
            <div><span :style="radioTextStyle" v-html="item.title"></span></div>
          </template>
        </v-radio>
      </div>
    </v-radio-group>


    <!--<wxc-radio v-for="(item,i) in updateList"
               :config="config"
               :radio-button-on-right="radioButtonOnRight"
               v-bind="item"
               :has-vertical-indent="hasVerticalIndent"
               :radio-item-style="radioItemStyle"
               :has-bottom-border="hasBottomBorder"
               @wxcRadioItemChecked="wxcRadioItemChecked(i,$event)"
               :key="i"></wxc-radio>-->
  </div>
</template>

<style scoped>

</style>

<script>
  import wxcRadio from './item.vue';

  export default {
    components: { wxcRadio },
    props: {
      list: {
        type: Array,
        default: () => ([])
      },
      config: {
        type: Object,
        default: () => ({})
      },
      label: {
        type: String,
        default: ""
      },
      radioButtonOnRight: {
        type: Boolean,
        default: true
      },
      hasBottomBorder: {
        type: Boolean,
        default: true
      }
    },
    data: () => ({
      checkedIndex: -1,
      radioModel:""
    }),
    computed: {
      updateList () {
        const { checkedIndex, list } = this;
        const updateList = [];
        list && list.forEach((item, i) => {
          item.checked = i === checkedIndex;
          if(item.checked) {
            this.radioModel = item.value
          }
          updateList.push(item);
        });
        return updateList;
      },
      radioItemStyle() {
        if(this.config.radioItemStyle) {
          return this.config.radioItemStyle;
        } else {
          return null;
        }
      },
      radioTextStyle() {
        return this.config && this.config.radioTextStyle
          ? this.config.radioTextStyle
          : {};
      },
      radioLabelStyle() {
        return this.config && this.config.radioLabelStyle
          ? this.config.radioLabelStyle
          : {};
      },
      hasVerticalIndent() {
        return this.config.hasVerticalIndent;
      }
    },
    watch: {
      list (newList) {
        this.setListChecked(newList);
      }
    },
    created () {
      this.setListChecked(this.list);
    },
    methods: {
      setListChecked(list){
        if (list && list.length > 0) {
          list.forEach((item, i) => {
            item.checked && (this.checkedIndex = i);
          });
        }
      },
      wxcRadioItemChecked (i, e) {
        const oldIndex = this.checkedIndex;
        const { value, title } = this.list[i];
        this.checkedIndex = i;
        this.$emit('wxcRadioListChecked', { value, title, oldIndex, index: i })
      },
      wxcRadioItemCheckedNew(itemValue) {
        this.$emit('wxcRadioListChecked', { value: itemValue })
      },
    }
  }
</script>
